<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="6">
        <material-card color="blue" flat full-width title="Параметры товаров">
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
          >
            <template #top>
              <v-toolbar flat>
                <v-text-field v-model="search" label="Поиск" class="mx-4" />
                <v-spacer />
                <v-dialog v-model="dialog">
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="() => newItem = true"
                    >
                      Новая запись
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Добавление параметра</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-text-field
                          v-model="editedItem.name"
                          label="Название"
                        />
                        <v-text-field
                          v-model="editedItem.slug"
                          label="Slug"
                        />
                        <v-select
                          v-model="editedItem.type"
                          :items="typeList"
                          label="Тип"
                          single-line
                        />
                        <v-checkbox
                          v-model="editedItem.hidden"
                          label="Скрыт"
                        />
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="blue darken-1" text @click="close">
                        Отмена
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Сохранить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template #item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
      <v-col cols="6">
        <material-card
          color="blue"
          flat
          full-width
          title="Значения параметров товаров"
        >
          <v-data-table
            :headers="headers_v"
            :items="data_v"
            :options.sync="options_v"
            :server-items-length="totalDesserts_v"
            :loading="loading_v"
          >
            <template #top>
              <v-toolbar
                flat
              >
                <v-spacer />
                <v-dialog
                  v-model="dialog_v"
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="() => newItem = true"
                    >
                      Новая запись
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Добавление значения параметра</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-autocomplete
                          v-model="editedItem_v.params_slug"
                          :items="data"
                          chips
                          color="blue-grey lighten-2"
                          label="Параметры"
                          item-text="name"
                          item-value="slug"
                        ></v-autocomplete>
                        <v-text-field
                          v-model="editedItem_v.value"
                          label="Значение"
                          @change="trans"
                        />
                        <v-text-field
                          v-model="editedItem_v.slug"
                          label="slug Значения"
                        />
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close_v"
                      >
                        Отмена
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save_v"
                      >
                        Сохранить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template #item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItemV(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-bucket
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { slugify } from 'transliteration'
import { getParams, createParam, updateParam, getParamsRangeValueTable, createParamsRangeValue, deleteParamsRangeValue, updateParamsRangeValue } from '@/graphql/offers'
export default {
  components: {
  },
  layout: 'dashboard',
  data () {
    return {
      headers: [
        {
          sortable: false,
          text: 'Slug',
          value: 'slug'
        },
        {
          sortable: false,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: false,
          text: 'Type',
          value: 'type'
        }, { text: 'Actions', value: 'actions', sortable: false }
      ],
      headers_v: [
        {
          sortable: false,
          text: 'Параметр',
          value: 'params_slug'
        },
        {
          sortable: false,
          text: 'Slug',
          value: 'slug'
        },
        {
          sortable: false,
          text: 'Значение',
          value: 'value'
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      data: [],
      options: {},
      totalDesserts: 0,
      loading: false,
      dialog: false,
      editedItem: {},
      typeList: ['String', 'Int', 'Range'],
      search: '',
      search_v: '',
      data_v: [],
      options_v: {},
      totalDesserts_v: 0,
      loading_v: false,
      dialog_v: false,
      editedItem_v: {},
      newItem_v: true,
      newItem: true
    }
  },
  apollo: {
    Params: {
      query: getParams,
      result ({ data, loading }) {
        if (data.getParams !== undefined && data.getParams.params !== null) {
          this.data = data.getParams.params
        }
        this.totalDesserts = data.getParams.count
        this.loading = false
      },
      variables () {
        return {
          search: this.search,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      update: data => data.getParams
    },
    ParamsRangeValue: {
      query: getParamsRangeValueTable,
      result ({ data }) {
        if (data !== undefined && data.getParamsRangeValueTable !== undefined && data.getParamsRangeValueTable !== null) {
          this.data_v = data.getParamsRangeValueTable.params_range_values
          this.totalDesserts_v = data.getParamsRangeValueTable.count
        }
        this.loading_v = false
      },
      variables () {
        return {
          limit: this.options_v.itemsPerPage,
          offset: this.options_v.itemsPerPage * (this.options_v.page - 1)
        }
      },
      update: data => data.getParamsRangeValue
    }
  },
  watch: {
      options (val) {
         this.loading = true
          this.$apollo.queries.Params.refetch()
      },
      options_v (val) {
        this.loading_v = true
        this.$apollo.queries.ParamsRangeValue.refetch()
      }
    },
    methods: {
      trans () {
        if (this.editedItem_v.slug === undefined || this.editedItem_v.slug.length < 1) {
          this.editedItem_v.slug = slugify(this.editedItem_v.value)
        }
      },
      UpdateParam (val) {
        this.editedItem_v.params_slug = val.slug
      },
      close () {
          this.dialog = false
      },
      close_v () {
        this.dialog_v = false
      },
      save () {
        if (this.newItem) {
          this.$apollo
              .mutate({
                mutation: createParam,
                variables: this.updateInputParams()
              })
              .then((data) => {
                this.$apollo.queries.Params.refetch()
              })
              .catch((error) => {
                console.error(error)
              })
        } else {
          this.$apollo
              .mutate({
                mutation: updateParam,
                variables: {
                  input: this.updateInputParams()
                }
              })
              .then((data) => {
                this.$apollo.queries.Params.refetch()
              })
              .catch((error) => {
                console.error(error)
              })
        }

        this.close()
        },
        updateInputParams () {
          return {
            slug: this.editedItem.slug,
            name: this.editedItem.name,
            type: this.editedItem.type,
            visible: this.editedItem.hidden ? 1 : 3
          }
        },
        save_v () {
            if (this.newItem_v) {
              this.$apollo.mutate({
                mutation: createParamsRangeValue,
                variables: this.editedItem_v
              }).then((data) => {
                this.$apollo.queries.ParamsRangeValue.refetch()
              }).catch((error) => {
                console.error(error)
              })
            } else {
              this.$apollo.mutate({
                mutation: updateParamsRangeValue,
                variables: this.editedItem_v
              }).then((data) => {
                this.$apollo.queries.ParamsRangeValue.refetch()
              }).catch((error) => {
                console.error(error)
              })
            }
          this.close_v()
        },
        editItem (item) {
          this.newItem = false
          this.editedItem = Object.assign({}, item)
          this.editedItem.hidden = item.visible !== 3
          this.dialog = true
        },
        editItemV (item) {
          this.newItem_v = false
          this.editedItem_v = Object.assign({}, item)
          this.dialog_v = true
        },
        deleteItem (item) {
          if (confirm('Удалить значение?')) {
            this.$apollo.mutate({
              mutation: deleteParamsRangeValue,
              variables: {
                id: item.id
              }
            }).then((data) => {
              this.$apollo.queries.ParamsRangeValue.refetch()
            }).catch((error) => {
              console.error(error)
            })
          }
        }
    }
}
</script>

<style></style>
